import styled from 'styled-components'
import colors from '../../../../shared/constants/colors'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'

const Header = styled.div`
  font-family: Roboto-Medium;
  font-size: 16px;
  color: ${colors.paroBlack};
  padding-bottom: 12px;
`

const FieldName = styled.div`
  color: #6a6a6a;
  font-size: 12px;
  margin-bottom: 8px;
`

const FieldValue = styled.div`
  font-size: 16px;
  color: ${colors.paroBlack};
`

const FieldText = styled.div`
  font-size: 14px;
  color: ${colors.paroBlack};
`

const StyledActions = styled(DialogActions)`
  display: flex;
  justify-content: space-between;
`

const StyledContent = styled(DialogContent)`
  overflow-x: hidden;
  /* padding: 30px; */
`

const FieldLabel = styled(FieldValue)`
  padding-bottom: 5px;
`
const StyledButton = styled(Button)`
  margin: 0px !important;
  padding-left: 0px !important;
  span {
    padding: 0px 5px;
  }
`

const ButtonContainer = styled(Box)`
  float: right;
  left: 0px;
  margin: 0px;
  position: absolute;
  top: -12px;
`

export {
  ButtonContainer,
  Header,
  FieldName,
  FieldValue,
  FieldText,
  FieldLabel,
  StyledActions,
  StyledContent,
  StyledButton,
}
